import { render, staticRenderFns } from "./SaveButton.vue?vue&type=template&id=bda21afc&scoped=true&"
import script from "./SaveButton.vue?vue&type=script&lang=js&"
export * from "./SaveButton.vue?vue&type=script&lang=js&"
import style0 from "./SaveButton.vue?vue&type=style&index=0&id=bda21afc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bda21afc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/johndwells/Git/hys/penge-polls/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bda21afc')) {
      api.createRecord('bda21afc', component.options)
    } else {
      api.reload('bda21afc', component.options)
    }
    module.hot.accept("./SaveButton.vue?vue&type=template&id=bda21afc&scoped=true&", function () {
      api.rerender('bda21afc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/vue/components/inputs/SaveButton.vue"
export default component.exports